import { PublicEntryNode } from './PublicEntryNode';
import { RoutingNode } from './RoutingNode';
import { ExtensionNode } from './ExtensionNode';
import { TimeConditionNode } from './TimeConditionNode';
import { IVRNode } from './IVRNode';
import { VoicemailNode } from './VoicemailNode';
import { TenantContextNode } from './TenantContextNode';

export { PublicEntryNode, RoutingNode, ExtensionNode, TimeConditionNode, IVRNode, VoicemailNode, TenantContextNode };

export const nodeTypes = {
  public_entry: PublicEntryNode,
  tenant_context: TenantContextNode,
  inbound_route: RoutingNode,
  outbound_route: RoutingNode,
  emergency_route: RoutingNode,
  extension: ExtensionNode,
  extension_group: ExtensionNode,
  time_condition: TimeConditionNode,
  ivr: IVRNode,
  ivr_menu: IVRNode,
  voicemail: VoicemailNode,
  voicemail_box: VoicemailNode,
};
